import { Button } from '@clickcease/cc-client-components-lib'
import { BzSetupPopup } from 'Features/bzSetupPopup/BzSetupPopup'
import { Connected } from 'Features/domainsManagement/components/DomainManagmentRow/DomainManagementRow.styled'
import { Setup } from 'Features/domainsManagement/components/Setup/Setup'
import { PlatformConnectionModal } from 'Features/platformConnectionModal/PlatformConnectionModal'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TableRow } from './ActiveDomainsTable'
import { PendingDomainsRowStyled, RowPart } from './DomainsTable.styled'
import { useGetPackagingLimits } from 'Features/accountSettings/api/getPackagingLimits'
import { GLOBAL_MODALS } from 'Types/GlobalModal'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { TagInstallation } from 'Features/domainsManagement/components/TagInstallation/TagInstallation'

type DomainRowProps = {
  data: TableRow
}

export const PendingDomainRow = ({ data }: DomainRowProps) => {
  const [modalToShow, setModalToShow] = useState<string>('')
  const { t } = useTranslation('dashboard')
  const { data: packagesData } = useGetPackagingLimits()
  const { owner } = useUserStore()
  const isPaidMarketingAllowed = packagesData?.paidMarketingAllowed
  const isBotZappingAllowed = packagesData?.botZappingAllowed

  const closeModal = () => setModalToShow('')

  return (
    <PendingDomainsRowStyled>
      <RowPart css={{ flex: '1.7' }}>
        <span>{data.address}</span>
      </RowPart>
      <RowPart css={{ flex: '0.9' }}>
        {data.paidMarketingConnected && (
          <Connected>{t('pending_domain_table.connected')}</Connected>
        )}
        {!data.paidMarketingConnected && isPaidMarketingAllowed && (
          <Setup
            disabled={!owner}
            onClick={() => setModalToShow(GLOBAL_MODALS.PLATFORM_CONNECTION)}
          />
        )}
      </RowPart>
      <RowPart css={{ flex: '0.9' }}>
        {data.botZappingConnected && <Connected>{t('pending_domain_table.connected')}</Connected>}
        {!data.botZappingConnected && isBotZappingAllowed && (
          <Setup disabled={!owner} onClick={() => setModalToShow(GLOBAL_MODALS.BM_SETUP)} />
        )}
      </RowPart>
      <RowPart css={{ flex: '0.5' }}>
        <Button
          text={t('pending_domain_table.get_tag')}
          variant={'outline'}
          onClick={() => setModalToShow(GLOBAL_MODALS.GET_TAG)}
          disabled={!owner}
        />
      </RowPart>
      <PlatformConnectionModal
        onOpenChange={closeModal}
        isOpen={modalToShow === GLOBAL_MODALS.PLATFORM_CONNECTION}
      />
      <BzSetupPopup
        isOpen={modalToShow === GLOBAL_MODALS.BM_SETUP}
        onOpenChange={closeModal}
        domainAddress={data.address}
      />
      <TagInstallation
        isOpen={modalToShow === GLOBAL_MODALS.GET_TAG}
        domainAddress={data.address}
        onOpenChange={closeModal}
      />
    </PendingDomainsRowStyled>
  )
}
